export default function PointServiceModel(dict) {
    if (!dict) {
        this.id = null;
        this.appId = null;
        this.campaignId = null;
        this.customizeAmount = null;
        this.divisible = null;
        this.amountPerUnit = null;
        this.unit = null;
        this.active = null;
        this.earn = null;
        return;
    }
    
    this.id = dict.Id;
    this.appId = dict.AppId;
    this.campaignId = dict.CampaignId;
    this.customizeAmount = dict.CustomizeAmount;
    this.divisible = dict.Divisible;
    this.amountPerUnit = dict.AmountPerUnit;
    this.unit = dict.Unit;
    this.active = dict.Active;
    this.earn = dict.Earn;
}